module.exports = __webpack_public_path__ + "static/media/download.44d99d9b.svg";